import React from 'react';
import { ArticleHeader, Render, Section, TeaserItemLink } from '../../platformui';

const IntroTheme = (props) => {
  const items = props.Items.map((item, index) => {
    return (
      <TeaserItemLink
        key={index}
        {...item}
        className="medium-6 large-4 c-teaser-outer columns"
      />
    );
  });

  return (
    <Section Modifiers={{ 'c-section--first': true, 'u-paper': true }}>
      <div className="c-intro-theme u-text-center">
        <div className="row c-intro-theme__header">
          <div className="columns medium-8 large-6 medium-centered u-text-center">
            <ArticleHeader Heading={props.Heading} Preamble={props.Preamble} />
          </div>
        </div>

        <div className="c-intro-theme__items row">
          <div className="medium-centered medium-10 large-10 columns">
            <div className="row u-flexwrap u-flexwrap--center">
              {Render.Property(items, 'ListRoot')}
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default IntroTheme;
